import React from 'react';

export default function IndexSectionContact8() {
    return (
        <React.Fragment>
            <>
                <section id={'contact'} className="pb-80 relative">
                    <img className="absolute bottom-0 left-0" src="cronos-assets/elements/light-warning-dark-green.svg"
                         alt/>
                    <img className="absolute bottom-0 right-0 transform rotate-90"
                         src="cronos-assets/elements/light-warning-dark-green.svg" alt/>
                    <div className="mb-5 pt-20 pb-12 bg-green-500">
                        <div className="container mx-auto px-4 pb-5 relative">
                            <div className="flex justify-center mb-6"/>
                            <h1 className="font-heading text-center text-white text-4xl max-w-2xl lg:text-5xl lg:max-w-5xl mx-auto font-bold mb-4">Got
                                questions?</h1>
                            <p className="text-green-100 text-center max-w-xl mx-auto mb-12">Have questions or feedback?
                                We'd love to hear from you! Reach out to us using the email below, and we'll get back to
                                you as soon as possible.</p>
                            <div className="bg-white shadow-sm" style={{marginBottom: '-200px'}}>
                                <div className="flex flex-wrap -m-4 justify-center">
                                    <div className="w-full lg:w-1/3 p-4">
                                        <div className="py-24 px-8 text-center h-full">
                                            <svg className="mx-auto" width={48} height={48} viewBox="0 0 48 48"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18 10L6 6V38L18 42M18 10L30 6M18 10V42M30 6L42 10V42L30 38M30 6V38M30 38L18 42"
                                                    stroke="#006251" strokeWidth="1.5" strokeLinecap="round"
                                                    strokeLinejoin="round"/>
                                            </svg>
                                            <h6 className="mt-3 mb-2 text-xl font-bold">Chat with us</h6>
                                            <p className="mb-1 text-gray-600">Reykjavik, Iceland</p>
                                            <p className="text-gray-600">Stockholm, Sweeden</p>
                                            <p className="text-gray-600">New York, USA</p>
                                        </div>
                                    </div>
                                    <div className="w-full lg:w-1/3 p-4">
                                        <div className="py-24 px-8 text-center h-full">
                                            <svg className="mx-auto" width={48} height={48} viewBox="0 0 48 48"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M41.9988 32.9533V38.3729C42.0072 40.4446 40.1444 42.1746 38.0528 41.9859C20 42 6 27.87 6.01413 9.93837C5.82575 7.85789 7.54715 6.00212 9.61622 6.00018H15.0465C15.9249 5.99155 16.7766 6.302 17.4426 6.87368C19.3363 8.49899 20.5543 14.0155 20.0856 16.2086C19.7197 17.9207 17.9938 19.1186 16.8204 20.2897C19.3972 24.8124 23.1493 28.5571 27.6809 31.1288C28.8544 29.9577 30.0546 28.2351 31.7702 27.87C33.9709 27.4016 39.523 28.6213 41.1418 30.5281C41.7158 31.2042 42.0208 32.0674 41.9988 32.9533Z"
                                                    stroke="#006251" strokeWidth="1.5" strokeLinecap="round"
                                                    strokeLinejoin="round"/>
                                            </svg>
                                            <h6 className="mt-3 mb-2 text-xl font-bold">Contact Us</h6>
                                            <p className="text-gray-600">contact@findameal.ai</p>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-center p-2">
                                        <div className="max-w-sm">
                                            <a className="px-6 py-3 rounded-lg block text-center bg-green-500 text-white text-sm font-bold hover:bg-green-600 focus:ring focus:ring-green-300 transition duration-200"
                                               href="mailto:contact@findameal.ai">Contact us</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}

